module.exports = __webpack_public_path__ + "img/subtract.433adc94.svg";